import dayjs from "../../../utils/dayjs";
import { daysJsFormat } from "../../../utils/constants";
import { diffWordsWithSpace } from "diff";
import React from "react";
import CustomTable from "../../../shared/components/CustomTable";
import { Button, Space } from "antd";
import { isArray } from "lodash";
import { t } from "i18next"; // Assuming you're using i18next for translations

const formatValue = (value, type) => {
  if (type === "Date" && value) {
    return dayjs(value).format(daysJsFormat.full);
  }
  return String(value);
};

const highlightDifference = (oldValue, newValue) => {
  const diffParts = diffWordsWithSpace(oldValue || "", newValue || "");
  return diffParts.map((part, index) => {
    const style = {
      color: part.added ? "green" : part.removed ? "red" : "black",
      backgroundColor: part.added
        ? "#a6f3a6"
        : part.removed
        ? "#f9d6d5"
        : "transparent",
      textDecoration: part.removed ? "line-through" : "none",
      fontWeight: part.added ? "bold" : "normal",
    };

    // If the part is unchanged but it's different in the old and new strings
    if (
      !part.added &&
      !part.removed &&
      part.value !== oldValue &&
      part.value !== newValue
    ) {
      style.color = "black";
    }

    return (
      <span key={index} style={style}>
        {part.value}
      </span>
    );
  });
};

export const ShowDifferences = ({ differences }) => {
  if (differences === undefined || isArray(differences) === false) {
    return null;
  }

  const [showDetail, setShowDetail] = React.useState(true);

  const col = [
    {
      title: t("showDifferences.actionTitle"),
      dataIndex: "kind",
      key: "kind",
      width: 150,
      render: (kind, record) => {
        let content = "";
        switch (record.kind) {
          case "N": // New value added
            content = t("showDifferences.added");
            break;
          case "D": // Value was deleted
            content = t("showDifferences.deleted");
            break;
          case "E": // Edited value
            content = t("showDifferences.edited");
            break;
          case "A": // Array change
            content = t("showDifferences.arrayChange");
            break;
          default:
            content = t("showDifferences.unknownChange");
        }
        return content;
      },
    },
    {
      title: t("showDifferences.fieldTitle"),
      dataIndex: "path",
      key: "path",
      render: path => {
        return <b>{path.join(".")}</b>;
      },
    },
    {
      title: t("showDifferences.oldValueTitle"),
      dataIndex: "lhs",
      key: "lhs",
      render: (lhs, record) => {
        return <code>{formatValue(lhs, record.type)}</code>;
      },
    },
    {
      title: (
        <Space>
          {t("showDifferences.newValueTitle")}
          <Button size={"small"} onClick={() => setShowDetail(!showDetail)}>
            {showDetail
              ? t("showDifferences.hideHighlight")
              : t("showDifferences.showHighlight")}
          </Button>
        </Space>
      ),
      dataIndex: "rhs",
      key: "rhs",
      render: (rhs, record) => {
        return (
          <code>
            {showDetail
              ? highlightDifference(
                  formatValue(record.lhs, record.type),
                  formatValue(rhs, record.type),
                )
              : formatValue(rhs, record.type)}
          </code>
        );
      },
    },
  ];

  return (
    <>
      <CustomTable
        columns={col}
        dataSource={differences}
        pagination={false}
        rowKey="path"
      ></CustomTable>
    </>
  );
};
